import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="container">
        <p>
          &copy; 2026 CarEx Marketplace. CarEx Marketplace is a product of
          Inspire The Next Inc.
        </p>
        <nav className="footer-links" aria-label="Legal and support">
          <Link to="/support">Support</Link>
          <Link to="/marketplace-policies">Marketplace policies</Link>
          <Link to="/terms">Terms</Link>
          <Link to="/privacy-policy">Privacy</Link>
        </nav>
        <p className="footer-contact">
          Customer service:{' '}
          <a href="mailto:support@carexmarket.com">support@carexmarket.com</a>
          {' · '}
          <a href="tel:+19173763763">+1 (917) 376-3763</a>
        </p>
      </div>
    </footer>
  );
};

export default Footer;

